import { render, staticRenderFns } from "./InternalLayout.vue?vue&type=template&id=70089799"
import script from "./InternalLayout.vue?vue&type=script&lang=js"
export * from "./InternalLayout.vue?vue&type=script&lang=js"
import style0 from "./InternalLayout.vue?vue&type=style&index=0&id=70089799&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports